// extracted by mini-css-extract-plugin
export var cancelButton = "GPReportModal-module--cancelButton--iB9ji";
export var content = "GPReportModal-module--content--HhAfG";
export var footer = "GPReportModal-module--footer--8MwXd";
export var header = "GPReportModal-module--header--h5lW0";
export var iconWrapper = "GPReportModal-module--iconWrapper--I22GQ";
export var noOrders = "GPReportModal-module--noOrders--OtfFQ";
export var thumbnail = "GPReportModal-module--thumbnail--7DR1r";
export var thumbnailBadge = "GPReportModal-module--thumbnailBadge--BFfsb";
export var thumbnailWrapper = "GPReportModal-module--thumbnailWrapper--lloL7";